import React from 'react';
import moment from 'moment';
import { chunksOf } from 'fp-ts/lib/Array';
export const useMonth = ({ date, appointments }) => {
    const days = React.useMemo(() => {
        const length = moment(date).daysInMonth();
        const monthDays = Array.from({ length }).map((_, index) => moment(date).add(index, 'days').startOf('day'));
        const start = monthDays[0];
        const end = monthDays[length - 1];
        const before = Array.from({ length: start.weekday() }).map((_, index) => start
            .clone()
            .subtract(index + 1, 'days')
            .toISOString());
        const after = Array.from({ length: 6 - end.weekday() }).map((_, index) => end
            .clone()
            .add(index + 1, 'days')
            .toISOString());
        return before
            .concat(monthDays.map((curr) => curr.toISOString()))
            .concat(after);
    }, [date]);
    const weeks = chunksOf(7)(days);
    const appointmentsByDay = React.useMemo(() => appointments === null || appointments === void 0 ? void 0 : appointments.filter((appointment) => moment(appointment.time).isSame(date, 'month')).reduce((appointmentsMap, appointment) => {
        var _a;
        const day = days.find((curr) => moment(curr).isSame(appointment.time, 'day'));
        if (!day)
            return appointmentsMap;
        if (!appointmentsMap[day])
            return Object.assign(Object.assign({}, appointmentsMap), { [day]: [appointment] });
        return Object.assign(Object.assign({}, appointmentsMap), { [day]: [appointment].concat((_a = appointmentsMap[day]) !== null && _a !== void 0 ? _a : []) });
    }, {}), [days, appointments]);
    return {
        days,
        weeks,
        appointmentsByDay
    };
};
//# sourceMappingURL=useMonth.js.map